import React from 'react';
import { useTheme } from '@material-ui/core';

interface CookieConsentProps {
  className?: string;
}

const CookieConsent = ({ className }: CookieConsentProps) => {
  const {
    palette: { primary },
  } = useTheme();

  return (
    <svg
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.4402 0.665527C73.8191 0.665527 75.7511 2.55579 75.7511 4.88336C75.7511 7.21093 73.8191 9.10119 71.4402 9.10119C69.0614 9.10119 67.1294 7.21093 67.1294 4.88336C67.1367 2.55579 69.0614 0.665527 71.4402 0.665527ZM72.5936 37.3988C76.3133 42.8298 81.0206 44.4943 87.1336 40.8196C87.3354 42.865 87.3859 44.9528 87.2777 47.0687C86.0739 70.4573 65.7238 88.4642 41.8197 87.2863C17.9229 86.1013 -0.480888 66.1901 0.722964 42.8086C1.91961 19.4201 22.9762 1.21568 46.873 2.39357C44.7537 8.88254 46.5486 14.645 51.9407 16.6058C47.0532 31.9678 57.9672 42.0186 72.5936 37.3988ZM22.313 34.3729C25.8957 34.3729 28.7936 37.2154 28.7936 40.7138C28.7936 44.2122 25.8885 47.0546 22.313 47.0546C18.7303 47.0546 15.8324 44.2122 15.8324 40.7138C15.8324 37.2154 18.7375 34.3729 22.313 34.3729ZM42.728 42.4559C44.7897 42.4559 46.4621 44.0923 46.4621 46.1095C46.4621 48.1267 44.7897 49.7631 42.728 49.7631C40.6663 49.7631 38.9939 48.1267 38.9939 46.1095C38.9867 44.0923 40.6591 42.4559 42.728 42.4559ZM26.5229 57.5075C29.0387 57.5075 31.0788 59.5036 31.0788 61.9652C31.0788 64.4268 29.0387 66.4228 26.5229 66.4228C24.007 66.4228 21.967 64.4268 21.967 61.9652C21.967 59.4965 24.007 57.5075 26.5229 57.5075ZM36.3411 23.3981C38.3163 23.3981 39.9094 24.9639 39.9094 26.8894C39.9094 28.822 38.3091 30.3808 36.3411 30.3808C34.3659 30.3808 32.7728 28.815 32.7728 26.8894C32.7728 24.9639 34.3731 23.3981 36.3411 23.3981ZM55.7325 59.0663C59.0413 59.0663 61.7157 61.6901 61.7157 64.9205C61.7157 68.1579 59.0341 70.7747 55.7325 70.7747C52.4237 70.7747 49.7493 68.1508 49.7493 64.9205C49.7493 61.6901 52.4309 59.0663 55.7325 59.0663ZM68.3333 16.9585C70.5536 16.9585 72.3558 18.7218 72.3558 20.8942C72.3558 23.0666 70.5536 24.8299 68.3333 24.8299C66.113 24.8299 64.3109 23.0666 64.3109 20.8942C64.3109 18.7218 66.113 16.9585 68.3333 16.9585Z"
        fill={primary.main}
      />
    </svg>
  );
};

CookieConsent.defaultProps = {
  className: '',
};

export default CookieConsent;
